import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AppConfigContext } from '@infl-ts/util-app-config';
import { transform } from '@infl-ts/util-public-image-url';
import { styled } from '@mui/material';
import { blurhashToCssGradientString } from '@unpic/placeholder';
import { Image as UnpicImage } from '@unpic/react';
import { useContext, useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Img = styled(UnpicImage)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var circumventUnpicAttributeCapitalization = function circumventUnpicAttributeCapitalization(imageRef, alt) {
  if (imageRef.current) {
    imageRef.current.setAttribute('aria-description', alt);
  }
};

export var CloudflareImage = function CloudflareImage(_ref) {
  var id = _ref.id,
      blurhash = _ref.blurhash,
      alt = _ref.alt,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx;
  var gradient = blurhashToCssGradientString(blurhash);
  var imageRef = useRef(null);

  var _useContext = useContext(AppConfigContext),
      baseImageUrl = _useContext.baseImageUrl;

  useEffect(function () {
    circumventUnpicAttributeCapitalization(imageRef, alt || '');
  }, [imageRef, alt]);
  return /*#__PURE__*/_jsx(Img, {
    ref: imageRef,
    layout: "fullWidth",
    src: id,
    background: gradient,
    transformer: transform(id, baseImageUrl),
    breakpoints: [360, 768, 1024, 1440, 1920],
    sx: _objectSpread({
      objectFit: 'cover'
    }, sx),
    "data-element": "Img",
    "data-component": "CloudflareImage",
    "data-source-file": "index.tsx"
  });
};